<template>
  <section>
    <left-menu />

    <div id="contentBack" class="back-link">
      <router-link v-bind:to="returnUrl">
        <i aria-hidden="true" class="fa fa-arrow-left"></i>
        <span>{{$t("Voltar")}}</span>
      </router-link>
    </div>

    <div id="mainContent" class="detail-holiday">

      <div class="row">
        <div class="col-xs-12 col-sm-12 col-md-12 box-content-title-page">
          <h1 class="certa">{{$t("Solicitação para o dia ")}}{{ detailAbsence.initDate | formatDate }}</h1>
        </div>

        <div class="col-xs-12 col-sm-12 col-md-12 offset-top-20">
          <!-- Box Filter -->
          <div class="col-xs-12 col-sm-12 col-md-12 default-box filter-box">
            <div class="box-content-details">
              <div class="content-photo">
                <img v-if="detailAbsence.employee.imageUri" v-bind:src="detailAbsence.employee.imageUri" class="content-photo-user" alt="user"/>
                <div v-if="!detailAbsence.employee.imageUri" class="empty-photo"><span>{{detailAbsence.employee.name | formatName}}</span></div>
                <router-link v-bind:to="'/perfil'">{{$t("Acessar perfil")}}</router-link>
              </div>
              <div class="content-infos">
                <div class="content-status" v-bind:class="{'status-warning': detailAbsence.userVacationStatus === 1, 'status-invalid': detailAbsence.userVacationStatus === 3, 'status-success': detailAbsence.userVacationStatus === 2}">{{ detailAbsence.userVacationStatusStr }}</div>
                <button v-on:click="checkCancelRequest()" v-if="detailAbsence.userVacationStatus === 1 && detailAbsence.employee.id === dataUser.id" class="cancel-absence"><i class="fa fa-times" aria-hidden="true"></i>{{$t("Cancelar")}}</button>
                <h2 v-if="detailAbsence.employee.name">
                  {{ detailAbsence.employee.name }}- <span>{{ detailAbsence.employee.email }}</span>
                </h2>

                <p><strong>{{$t("Tipo da solicitação:")}}</strong> {{ detailAbsence.userVacationTypeStr }} </p>
                <p><strong>{{$t("Período:")}}</strong> {{ detailAbsence.initDate | formatDate }} - {{detailAbsence.endDate | formatDate}}  ({{diffDays ? diffDays : '1'}} {{diffDays > 1 ? 'dias' : 'dia'}})</p>
                <p><strong>{{$t("Observação:")}}</strong> {{ detailAbsence.requestNotes }} </p>
                <p v-if="detailAbsence.imageUri"><strong>{{$t("Anexo:")}}</strong>
                  <a v-if="detailAbsence.imageUri" v-bind:href="detailAbsence.imageUri" target="_blank">{{$t("Ver anexo")}}</a>
                  <span v-else>-</span>
                </p>
                <p v-if="detailAbsence.manager.name"><strong>{{detailAbsence.userVacationStatus === 3 ? this.$t("Reprovado") : this.$t("Aprovado/Cadastrado")}} {{$t("por:")}}</strong> {{ detailAbsence.manager.name }} {{$t("em")}} {{detailAbsence.createdAt | formatDateHours}} </p>
              </div>

              <div v-bind:class="{'offset-top-50': !detailAbsence.imageUri, 'offset-top-20': detailAbsence.imageUri}" v-if="detailAbsence.userVacationStatus === 1 && showAllMenu.isManager && detailAbsence.employee.id !== dataUser.id" class="line-block"></div>

              <div v-if="detailAbsence.userVacationStatus === 1 && showAllMenu.isManager && detailAbsence.employee.id !== dataUser.id" class="box-avalitaion">
                <h5>{{$t("Avalie a solicitação")}}</h5>


                <div class="double-btns">
                  <button v-on:click="dataApprove.approve = false" class="default-secondary-back" v-bind:class="{'red-color': dataApprove.approve === false}">
                    <ion-icon name="close-circle-outline"></ion-icon>
                    <span>{{$t("Recusar")}}</span>
                  </button>
                  <button v-on:click="dataApprove.approve = true" class="default-secondary-back" v-bind:class="{'green-color': dataApprove.approve}">
                    <ion-icon name="checkmark-circle-outline"></ion-icon>
                    <span>{{$t("Aprovar")}}</span>
                  </button>
                </div>

                <div class="checkbox">
                  <input id="check1" type="checkbox" v-model="dataApprove.sendEmail">
                  <label for="check1"><span>{{$t("Enviar notificação por e-mail")}}</span></label>
                </div>

                <button v-on:click="checkSendAvaliation()" class="default-btn-bue">
                  <div v-if="loadingSend" class="loading-btn">
                    <div class="spinner-btn">
                      <div class="rect1"></div>
                      <div class="rect2"></div>
                      <div class="rect3"></div>
                      <div class="rect4"></div>
                      <div class="rect5"></div>
                    </div>
                  </div>
                  <span v-else>{{$t("Finalizar solicitação")}}</span>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <!-- Footer -->
    <vue-footer/>
  </section>
</template>

<script>
import leftMenu from '../../components/leftMenu.vue'
import vueFooter from "../../components/footer";
import fullLoading from "../../components/blueFullLoading";
import swal from 'sweetalert';

import {ABSENCE_APPROVE_MANAGER, ABSENCE_CANCEL, DETAIL_ABSENCE} from "../../../../urlConfig";
import { REQUEST_SERVICE } from "../../../../requestConfig";
import { UTIL_SERVICE } from "../../../../utils";

export default {
  name: 'detail-holiday',
  components: {
    fullLoading,
    leftMenu,
    vueFooter
  },
  data() {
    return {
      showAllMenu: null,
      returnUrl: '',
      loadingSend: false,
      dataApprove: {
        approve: null,
        sendEmail: false,
      },
      dataUser: {
        company: {}
      },
      detailAbsence: {
        imageUri: null,
        employee: {
          name: null,
          imageUri: null,
          email: null
        },
        manager: {
          name: null,
          imageUri: null,
          email: null
        }
      },
      diffDays: 0,
      failRequest: false,
      loadingList: false
    }
  },
  methods: {
    checkCancelRequest() {
      swal({
        title: 'Aviso',
        text: 'Tem certeza que deseja cancelar a solicitação?',
        buttons: ["Cancelar", "Sim, continuar"],
      }).then(value => {
        if (value) {
          this.cancelRequest();
        }
      }).catch(err => {
        swal.stopLoading();
        swal.close();
      });
    },
    cancelRequest() {
      if (!this.loadingSend) {
        this.loadingSend = true;
        REQUEST_SERVICE.get(`${ABSENCE_CANCEL}${this.$route.params.idRequest}/cancel`).then((response) => {
          UTIL_SERVICE.console("RESULT ABSENCE_CANCEL:", response.data);

          swal("Sucesso", 'Solicitação cancelada com sucesso.', "success");

          this.$router.push({path: '/lista-de-ferias-afastamento'});

          this.loadingSend = false;
        }).catch(reason => {
          this.loadingSend = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal(this.$t("Aviso"), value.value, "error");
          });
        });
      }
    },
    checkSendAvaliation() {
      if (this.dataApprove.approve || this.dataApprove.approve === false) {
        this.loadingSend = true;
        const objectSend = {
          id: this.$route.params.idRequest,
          userVacationStatus: '',
          sendEmail: this.dataApprove.sendEmail
        };

        if (this.dataApprove.approve) {
          objectSend.userVacationStatus = 2;
        } else if (this.dataApprove.approve === false) {
          objectSend.userVacationStatus = 3;
        }

        UTIL_SERVICE.console("Data send:", objectSend);
        REQUEST_SERVICE.put(ABSENCE_APPROVE_MANAGER, objectSend).then((response) => {
          UTIL_SERVICE.console("RESULT ABSENCE_APPROVE_MANAGER:", response.data);

          this.detailAbsence.userVacationStatus = objectSend.userVacationStatus;
          if (objectSend.userVacationStatus === 2) {
            this.detailAbsence.userVacationStatusStr = 'Aprovado';
          } else {
            this.detailAbsence.userVacationStatusStr = 'Recusado';
          }
          this.loadingSend = false;
        }).catch(reason => {
          this.loadingSend = false;
          // Show errors.
          reason.response.data.erros.map((value, index) => {
            swal(this.$t("Aviso"), value.value, "error");
          });
        });
      }
    },
    calcDays() {
      if (this.detailAbsence.initDate && this.detailAbsence.endDate) {
        const timeDiff = Math.abs(this.detailAbsence.endDate.getTime() - this.detailAbsence.initDate.getTime());
        this.diffDays = Math.ceil(timeDiff / (1000 * 3600 * 24));
      }
    },
    getDetailAbsence() {
      this.loadingList = true;
      REQUEST_SERVICE.get(DETAIL_ABSENCE + this.$route.params.idRequest).then((response) => {
        UTIL_SERVICE.console("RESULT DETAIL_ABSENCE:", response.data);

        this.detailAbsence = response.data;
        this.detailAbsence.initDate = new Date(response.data.initDate);
        this.detailAbsence.endDate = new Date(response.data.endDate);
        this.calcDays();

        this.loadingList = false;
      }).catch(reason => {
        this.loadingList = false;
        // Show errors.
        reason.response.data.erros.map((value, index) => {
          swal(this.$t("Aviso"), value.value, "error");
        });
      });
    }
  },
  beforeMount(){
    this.dataUser = JSON.parse(window.localStorage.getItem('userInfo'));
    try {
      this.showAllMenu = JSON.parse(window.localStorage.getItem('configMenu'));
    } catch (e) {}
    this.getDetailAbsence();

    if (this.$route.params.returnType === '1') {
      this.returnUrl = '/gerenciar-ferias-afastamento'
    } else {
      this.returnUrl = '/lista-de-ferias-afastamento';
    }
  }
}
</script>


<style lang="scss" scoped>
.detail-holiday {

  .filter-box {
    min-height: 274px;
  }

  .box-content-details {
    display: block;
    width: 100%;
    padding-top: 10px;
    padding-bottom: 20px;
    position: relative;

    .content-photo {
      width: 200px;
      position: absolute;
      left: 0;
      top: 0;

      .content-photo-user,.empty-photo {
        position: relative;
        top: 30px;
        display: block;
        width: 125px;
        height: 125px;
        background: var(--bodyColor);
        border-radius: 100%;
        object-fit: cover;
        text-align: center;
        margin: 0 auto;

        span {
          font-size: 30px;
          font-weight: bold;
          top: 40px;
          position: relative;
          text-transform: uppercase;
          font-family: "Montserrat", sans-serif;
        }
      }

      a {
        height: 25px;
        font-family: "Montserrat", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        color: var(--linkColor);
        border: 1px solid var(--linkColor);
        cursor: pointer;
        border-radius: 40px;
        padding: 4px 0;
        width: 130px;
        margin: 44px auto 0;
        left: 0;
        right: 0;
        text-align: center;
        display: block;
        line-height: 15px;

        &:hover {
          text-decoration: none;
        }
      }
    }

    .content-infos {
      margin-left: 200px;
      padding-right: 200px;
      position: relative;

      .content-status {
        position: absolute;
        right: 14px;
        top: 0;
        height: 30px;
        border-radius: 40px;
        padding: 4px 16px;
        font-family: "Montserrat", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 14px;
        line-height: 22px;
        color: #FFFFFF;
      }

      .status-success {
        background: #2ACC6B;
      }
      .status-warning {
        color: #3A424E;
        background: #FDD944;
      }
      .status-invalid {
        background: #FF445D;
      }

      .cancel-absence {
        font-family: "Montserrat", sans-serif;
        font-style: normal;
        font-weight: 400;
        font-size: 16px;
        color: #FF445D;
        border: none;
        background: transparent;
        cursor: pointer;
        position: absolute;
        right: 18px;
        top: 40px;

        i {
          font-size: 14px;
          margin-right: 4px;
        }

        &:hover {
          border-bottom: 1px solid #FF445D;
        }
      }

      h2 {
        font-style: normal;
        font-weight: 700;
        font-size: 24px;
        display: block;
        margin-bottom: 20px;
        color: var(--linkColor);
        font-family: "Montserrat", sans-serif;
      }

      p {
        font-family: "Montserrat", sans-serif;
        font-style: normal;
        font-weight: 500;
        font-size: 18px;
        color: #3A424E;
        margin: 0 0 10px;
        display: block;

        strong {
          font-family: "Montserrat", sans-serif;
        }

        a {
          color: var(--linkColor);
          cursor: pointer;
          font-family: "Montserrat", sans-serif;
        }
      }
    }
  }

  .line-block {
    display: block;
    height: 1px;
    background: #eeeeee;
    width: 100%;
  }

  .box-avalitaion {
    position: relative;
    right: 14px;
    max-width: 600px;
    top: 0;
    width: 100%;
    padding-left: 50px;
    display: block;
    margin-top: 20px;
    margin-bottom: 20px;

    h5 {
      font-style: normal;
      font-weight: 700;
      font-size: 21px;
      font-family: "Montserrat", sans-serif;
      color: var(--titleText);
    }

    .checkbox {
      position: relative;
      left: 19px;
      margin-top: 0;
      margin-bottom: 20px;

      label {
        position: relative;
        top: -1px;
      }
    }

    .double-btns {
      display: block;
      margin: 20px 0 0;

      .default-secondary-back {
        display: inline-block;
        width: calc(100% / 2 - 15px);
        text-align: center;
        background: var(--btnBkSide);
        border: 1px solid var(--btnBkSide);
        cursor: pointer;
        margin: 0 0 20px;
        min-width: 120px;
        font-family: "Montserrat", sans-serif;
        height: 36px;
        border-radius: 4px !important;
        line-height: 34px;

        span, ion-icon {
          display: inline-block;
          color: var(--iconSide);
        }

        ion-icon {
          position: relative;
          top: 2px;
        }

        &:first-of-type {
          margin-right: 10px;
        }

        &:last-of-type {
          margin-left: 10px;
        }

        &:hover {
          background: #BACADC;
        }
      }
    }

    .default-btn-bue {
      display: block;
      width: 100%;
      font-weight: 400;
      font-size: 16px;
      height: 36px;
      font-family: "Montserrat", sans-serif;
    }

    .green-color {
      background: var(--greenColor) !important;
      span, ion-icon {
        color: #ffffff !important;
      }
    }
    .red-color {
      background: var(--redColor) !important;
      span, ion-icon {
        color: #ffffff !important;
      }
    }
  }

}
</style>



// WEBPACK FOOTER //
// src/vue/views/restricted/holiday/detailHoliday.vue